import { render, staticRenderFns } from "./Motivationstext.vue?vue&type=template&id=25dc4b21&scoped=true&"
import script from "./Motivationstext.vue?vue&type=script&lang=js&"
export * from "./Motivationstext.vue?vue&type=script&lang=js&"
import style0 from "./Motivationstext.vue?vue&type=style&index=0&id=25dc4b21&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25dc4b21",
  null
  
)

export default component.exports